import React, { Component } from "react";

import { Row, Col, Image} from 'react-bootstrap';
import logoSiman from '../../Resources/Images/logo-footer.png';
import { FaFacebookF ,FaInstagram,FaTwitter,FaYoutube,FaGooglePlay} from 'react-icons/fa';
import {Link} from "react-router-dom";
import configs from '../../Config.json';

class Footer extends Component {
  
    render() {
      let country = '';
      if (this.props.varPais === configs[0].paisSV) {country = 'elsalvador/'}
      if (this.props.varPais === configs[0].paisGT) {country = 'guatemala/'}
      if (this.props.varPais === configs[0].paisCR) {country = 'costarica/'}
      if (this.props.varPais === configs[0].paisNI) {country = 'nicaragua/'}
      var year = new Date();

        return(
          <div className="clubes--row-footer">
          <Row className="clubes--row flex-justify-content-center pb-3 mt-4 pt-4">
                
                <Col lg={4} md={4} sm={12} xs={12} className="clubes--nav-item clubes--nav-item-logo-footer d-flex justify-content-center"> 
                  <Image className="clubes--logo-siman" src={logoSiman}/>    
                </Col>

                <Col lg={4} md={4} sm={12} xs={12} className="d-flex justify-content-around clubes--footer-item">

                      <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(configs[0].facebookBase+country)}} >
                        <FaFacebookF className="clubes--social-icons" color="#565656" size="2em"/> 
                      </Link>
                
                      <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(configs[0].instagram)}} >
                          <FaInstagram className="clubes--social-icons" color="#565656" size="2em"></FaInstagram> 
                      </Link>

                      <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(configs[0].twitter)}} >
                        <FaTwitter className="clubes--social-icons" color="#565656" size="2em"></FaTwitter>
                      </Link>

                      <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(configs[0].youtube)}} >
                        <FaYoutube className="clubes--social-icons" color="#565656" size="2em"></FaYoutube>
                      </Link>
                    
                      <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(configs[0].playStore)}} >
                        <FaGooglePlay className="clubes--social-icons" color="#565656" size="2em"></FaGooglePlay> 
                      </Link> 
                </Col>
                <Col lg={4} md={3} sm={12} xs={12} className="clubes--nav-item clubes--pay-items">
                    <Image className="p-2" src='https://siman.vtexassets.com/arquivos/credisiman-icon.png' /> 
                    <Image className="p-2" src='https://siman.vtexassets.com/arquivos/visa-icon.png' /> 
                    <Image className="p-2" src='https://siman.vtexassets.com/arquivos/mastercard-icon.png' />
                    <Image className="p-2" src='https://siman.vtexassets.com/arquivos/pay-icon.png' />    
                    <Image className="p-2" src='https://siman.vtexassets.com/arquivos/american-icon.png' /> 
                </Col>
          </Row>
          <Row className="clubes--row clubes--footer-copy justify-content-center bg-siman">
            <p>© 2000 - { year.getFullYear() } Copyright Almacenes Siman El Salvador. Reservados todos los derechos.</p>
          </Row>
          </div>
        )
    }
}

export default Footer;